import { Component, OnInit, OnDestroy } from '@angular/core';
import { TeamChatService } from 'src/app/core/services/team-chat.service';
import { ITeamChatThread, ITeamChatMessage } from 'src/app/core/models/team-chat';
import { Subscription } from 'rxjs';
import { UserProfileService } from 'src/app/core/services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-team-chat',
  templateUrl: './team-chat.component.html',
  styleUrls: ['./team-chat.component.scss']
})
export class TeamChatComponent implements OnInit, OnDestroy {

  threads: ITeamChatThread[] = [];
  selectedThread?: ITeamChatThread;
  messages: ITeamChatMessage[] = [];
  showUsersSheet = false;

  users: any[] = [];
  newMessage = '';
  typingUsers: Set<string> = new Set();

  subscriptions: Subscription[] = [];

  myUserId: string = localStorage.getItem('userId') || '';

  constructor(
    private chatService: TeamChatService,
    private userService: UserProfileService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.loadThreads();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());

    if (this.selectedThread) {
      this.chatService.leaveThread(this.selectedThread._id);
    }
  }

  // ================= THREADS =================

  async loadThreads() {
    try {
      const data = await this.chatService.listThreads().toPromise();
      this.threads = data?.threads || [];
    } catch (err) {
      console.error('Thread load error', err);
    }
  }

  async selectThread(thread: ITeamChatThread) {

    if (this.selectedThread) {
      this.chatService.leaveThread(this.selectedThread._id);
    }

    this.selectedThread = thread;

    this.chatService.joinThread(thread._id);

    try {
      const data = await this.chatService
        .listMessages(thread._id)
        .toPromise();

      this.messages = data?.messages || [];

      await this.chatService.markThreadRead(thread._id).toPromise();

    } catch (err) {
      console.error('Message load error', err);
    }
  }

  // ================= USERS =================

  loadUsers() {

    this.userService.getAllUsers({
      page: 1,
      limit: 100
    }).subscribe(res => {

      const allowedRoles = [
        'SUPER_ADMIN',
        'OPERATOR',
        'CLINIC_ADMIN'
      ];

      this.users = res.users.filter(user =>
        allowedRoles.includes(user.role) &&
        user._id !== this.myUserId
      );

    });

  }

  // ================= START CHAT =================

  async startChat(userId: string, modal: any) {

    try {

      const res: any = await this.chatService
        .openThread([this.myUserId, userId])
        .toPromise();

      const thread = res.data.thread;   // ✅ correct path

      // thread ko list me add karo
      this.threads = [thread, ...this.threads];

      // thread open karo
      await this.selectThread(thread);

      // modal close
      modal.close();

    } catch (err) {
      console.error('Open thread error', err);
    }

  }

  // ================= SEND MESSAGE =================

  async sendMessage() {

    if (!this.newMessage.trim() || !this.selectedThread) return;

    try {

      const res = await this.chatService
        .sendMessage(this.selectedThread._id, this.newMessage)
        .toPromise();

      const message = res.message;

      this.messages.push(message);

      this.newMessage = '';

    } catch (err) {
      console.error('Send message error', err);
    }

  }

  typing() {

    if (!this.selectedThread) return;

    this.chatService.sendTyping(
      this.selectedThread._id,
      !!this.newMessage.trim()
    );

  }

  // ================= MODAL =================

  openUsersModal(content: any) {

    this.loadUsers();

    this.modalService.open(content, {
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });

  }

  // ================= HELPERS =================

  getParticipantsNames(thread: ITeamChatThread) {

    return thread.participants
      ?.filter(p => p._id !== this.myUserId)
      .map(p => p.fullName)
      .join(', ') || '';

  }

  getInitials(name: string): string {

    if (!name) return '?';

    const parts = name.trim().split(' ');

    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }

    return (
      parts[0].charAt(0) +
      parts[parts.length - 1].charAt(0)
    ).toUpperCase();

  }

  formatTime(date: any): string {

    if (!date) return '';

    const d = new Date(date);

    return d.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    });

  }

}